import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgUsageSelector } from '../../../redux/app/selectors/organization';
import { UsageGraphSection } from './UsageGraphSection';

export const InboundOutboundUsageStats = () => {
  const {
    region: {
      aggregateStats: {
        totalInboundBalance, totalOutboundBalance, totalInboundSegments, totalOutboundSegments,
      },
      directionPieData,
    },
  } = useSelector(orgUsageSelector);

  const pieTableRows = directionPieData.map((row) => (
    <tr>
      <td>
        <span className="circle" style={{ background: row.color }} />
        &nbsp;&nbsp;
        <span className="fsz-11 bold-800" style={{ color: row.textColor }}>{row.name}</span>
      </td>
      <td>
        <span className="fsz-11 bold-800" style={{ color: row.textColor }}>{row.value}</span>
      </td>
    </tr>
  ));

  return (
    <>
      <UsageGraphSection datas={directionPieData} rows={pieTableRows} />
      <table>
        <thead>
          <tr>
            <td>Type</td>
            <td>Average Rate</td>
            <td># of Segments</td>
            <td>Balance</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Inbound</td>
            <td />
            <td>{totalInboundSegments}</td>
            <td>
              $
              {totalInboundBalance}
            </td>
          </tr>
          <tr>
            <td>Outbound</td>
            <td />
            <td>{totalOutboundSegments}</td>
            <td>
              $
              {totalOutboundBalance}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
